export default {
  serverValidationErrors: [],
  isContentLoading: false,
};
